import axios from 'axios';
import queryString from 'querystring';

const axiosByJson = axios.create({
  // baseURL: 'http://localhost:1031/zhizhu/',
  // baseURL: 'http://101.132.135.39:1031/zhizhu/',
  baseURL: 'https://www.zhangyunnet.cn/zhizhu/',

  headers: {
    'Content-Type': 'application/json',
  },
});

const axiosByKeyValue = axios.create({
  // baseURL: 'http://101.132.135.39:1031/zhizhu/',
  baseURL: 'https://www.zhangyunnet.cn/zhizhu/',
  // baseURL: 'http://localhost:1031/zhizhu/',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  transformRequest(data) {
    return queryString.stringify(data);
  },
});

export {
  axiosByJson,
  axiosByKeyValue,
};



// WEBPACK FOOTER //
// ./src/axios/index.js